<div class="modal {active ? 'is-active': ''}">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Favorite Inning Lineup</p>
            <button class="delete" aria-label="close" on:click='set({active: false})'></button>
        </header>
        <section class="modal-card-body">
            <div class='columns'>
                <div class='column is-half'>
                    <div class="field">
                        <label class="label">Lineup Name</label>
                        <div class="control">
                            <input bind:value=lineupName class="input" type="text" placeholder="Name this lineup ...">
                        </div>
                    </div>
                </div>

                <div class='column is-half'>
                    <nav class='panel'>
                        <div class='panel-heading has-background-primary has-text-white'>
                            Fielding
                        </div>
                        <p class='panel-block roster-player'>
                            <span class='panel-icon lineup-id'>P</span>
                            {#if inning[1].last}
                                {inning[1].last}
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player'>
                            <span class='panel-icon lineup-id'>C</span>
                            {#if inning[2].last}
                                {inning[2].last}
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player'>
                            <span class='panel-icon lineup-id'>1st</span>
                            {#if inning[3].last}
                                {inning[3].last}
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player'>
                            <span class='panel-icon lineup-id'>2nd</span>
                            {#if inning[4].last}
                                {inning[4].last}
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player'>
                            <span class='panel-icon lineup-id'>3rd</span>
                            {#if inning[5].last}
                                {inning[5].last}
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player'>
                            <span class='panel-icon lineup-id'>SS</span>
                            {#if inning[6].last}
                                {inning[6].last}
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player'>
                            <span class='panel-icon lineup-id'>LF</span>
                            {#if inning[7].last}
                                {inning[7].last}
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player'>
                            <span class='panel-icon lineup-id'>CF</span>
                            {#if inning[8].last}
                                {inning[8].last}
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                        <p class='panel-block roster-player'>
                            <span class='panel-icon lineup-id'>RF</span>
                            {#if inning[9].last}
                                {inning[9].last}
                            {:else}
                                &nbsp;
                            {/if}
                        </p>
                    </nav>
                </div>

            </div>
        </section>
        <footer class="modal-card-foot">
            <button class="button is-primary" on:click='bookmarkLineup()'>Save</button>
            <button class="button" on:click='closeDialog()'>Cancel</button>
        </footer>
    </div>
</div>

<script>
    export default {
        data() {
            return {
                active: false,
                inning: [],
                lineupName: ''
            };
        },
        computed: {

        },
        methods: {
            bookmarkLineup() {
                const {inning, lineupName} = this.get();
                const {bookmarkedLineups} = this.store.get();
                bookmarkedLineups[lineupName] = inning;
                this.store.set({bookmarkedLineups});
                this.set({active: false});
            },
            closeDialog() {
                this.set({active: false});
            }

        }
    }
</script>

<style>
    .fa-lg {
        line-height: 1em;
    }
    .panel-icon {
        vertical-align: inherit;
    }
    .roster-player {
        display: block;
        padding: 0.4em 0.75em;
    }
</style>
